/**
 * Resolves the VWO FME accountId and sdkKey for the current brand and environment.
 */

type VwoFmeEnv = 'prod' | 'staging' | 'dev';

function resolveVwoFmeEnv(): VwoFmeEnv {
	const envName = process.env.ENVIRONMENT_NAME;
	if (envName === 'prod') return 'prod';
	if (envName === 'stage') return 'staging';
	return 'dev';
}

export function getVwoFmeSdkKey(config: BrandThemeConfig): string | undefined {
	const vwoFme = config.vwoFme;
	if (!vwoFme) return undefined;

	const env = resolveVwoFmeEnv();
	return vwoFme.sdkKey?.[env];
}

export function getVwoFmeAccountId(config: BrandThemeConfig): string | undefined {
	return config.vwoFme?.accountId;
}
